import styled from 'styled-components';
import { Card } from 'antd';

// Styled components for AI JDV Listing page - following Campaign card pattern

// AI JDV Card matching Figma design
export const AIJDVCard = styled(Card)`
  width: 100%;
  border-radius: 12px;
  border: 1px solid #e2e8ee;
  background: ${({ theme }) => theme.settings.whiteColor};
  box-shadow: 0px 0px 8px rgba(50, 50, 50, 0.05);
  cursor: pointer;
  transition: all 0.2s ease;
  scale: 1;
  &:hover {
    scale: 1.02;
    box-shadow: 0px 4px 8px rgba(50, 50, 50, 0.1);
    border-color: ${({ theme }) => theme.settings.borderColor};
    transition: all 0.2s ease;
  }

  .ant-card-body {
    padding: 0;
  }

  &.ant-card-loading {
    .ant-card-body {
      padding: 20px 24px;
    }
  }
`;

export const AIJDVCardInner = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 20px 24px;
`;

export const AIJDVCardHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const AIJDVCardInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  min-width: 0;
`;

export const AIJDVCardTitle = styled.div`
  cursor: pointer;
  color: ${({ theme }) => theme.settings.tertiary};
  font-family: ${({ theme }) => theme.fonts.inter};
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AIJDVCardDuration = styled.div`
  display: inline-flex;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: ${({ theme }) => theme.settings.tertiary};

  img {
    width: 14px;
    height: 14px;
    margin-right: 6px;
    flex-shrink: 0;
  }
`;

export const AIJDVCardFooter = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 8px;
`;

export const AIJDVCardDate = styled.div`
  display: inline-flex;
  align-items: center;
  font-family: ${({ theme }) => theme.fonts.inter};
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: ${({ theme }) => theme.settings.textColor};

  img {
    width: 14px;
    height: 14px;
    margin-right: 6px;
    flex-shrink: 0;
  }
`;

export const AIJDVCardMenuIcon = styled.span`
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0px;
  border-radius: 4px;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(0, 0, 0, 0.05);
  }

  img {
    width: 14px;
    height: 16px;
  }
`;

export const AIJDVTableActionWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
`;
